import useApiLoading from "@/hooks/common/general/legacy/use-api-loading";
import CustomSpinner from "@Components/custom-spinner";
import { AppContext, UnityBridge } from "@Context/common/general/context";
import { Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import React, { useEffect, useState } from "react";

const timeout = 120000;
// Buffer time prevents loader from closing between multiple chained actions are dispatched, stops flickering between multiple actions calls
const bufferTime = 500;

// Use this raw value outside the scope of the pure react function
// to workaround JS closure set by useEffect, preventing loadStack from updating in new React version..
let loadingStackRaw = 0;

export default function () {
  const { state } = React.useContext(AppContext);
  const apiLoading = useApiLoading(undefined, { blockingOnly: true });
  const [loadingStack, setLoadingStack] = useState(0);

  const blurKeyboard = () => {
    UnityBridge.dispatchWebEvent({
      type: UnityBridge.OutgoingWebEvents.TextFieldBlurred,
      payload: {},
    });
  };

  const onEnableLoader = (loadPromise: Promise<void>, timeoutCallback = () => {}) => {
    if (!loadPromise || !loadPromise.then) return;
    loadingStackRaw = loadingStackRaw + 1;
    setLoadingStack(loadingStackRaw);

    let autoTimeout = setTimeout(() => {
      loadingStackRaw = loadingStackRaw <= 0 ? 0 : loadingStackRaw - 1;
      setLoadingStack(loadingStackRaw);
      blurKeyboard();
      timeoutCallback();
    }, timeout);

    loadPromise.then(() => {
      setTimeout(() => {
        loadingStackRaw = loadingStackRaw <= 0 ? 0 : loadingStackRaw - 1;
        setLoadingStack(loadingStackRaw);
        blurKeyboard();
      }, bufferTime);
      clearTimeout(autoTimeout);
    });
  };

  const onDisableLoader = () => {
    loadingStackRaw = 0;
    setLoadingStack(loadingStackRaw);
  };

  useEffect(() => {
    state.loading.events.enableLoader.on(onEnableLoader);
    state.loading.events.resetLoader.on(onDisableLoader);
  }, []);

  return loadingStack > 0 || apiLoading ? (
    <Box
      id={"LOADER"}
      sx={{
        top: 0,
        left: 0,
        flexGrow: 1,
        height: "100%",
        width: "100%",
        position: "fixed",
        zIndex: "10000",
      }}
    >
      {!state.device.isVR ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            height: "calc(100vh)",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <CustomSpinner />
      )}
    </Box>
  ) : null;
}
